module.exports = __webpack_public_path__ + "img/re_event1_mo.8b119660.png";